import React, { useContext, useState } from 'react'
import { leadCardPreviewContext } from './context'

function MissingImageNotice() {
  return (
    <div
      data-testid="no-background-image"
      className="no-image mb-5"
      style={{
        maxWidth: '280px',
        minWidth: '252px',
        textAlign: 'center',
        margin: '0 auto',
        height: '168px',
        position: 'relative',
      }}
    >
      <div style={{ position: 'absolute', bottom: 0 }}>
        <i className="fas fa-images fa-3x" />
        <div
          className="no-image-notice"
          style={{
            background: '#4B5563',
            borderRadius: '4px',
            color: '#F3F4F6',
            fontSize: '11px',
            padding: '4px 12px',
          }}
        >
          The image creative used in your ad will show up here.
        </div>
      </div>
    </div>
  )
}

export function BackgroundPreview() {
  const { leadCard } = useContext(leadCardPreviewContext)
  const [failedSource, setFailedSource] = useState<string>()

  // @ts-ignore - john
  const source: string | undefined = leadCard.pagePhoto?.source ?? leadCard.intro.imageURL

  // Facebook signs its image URLs with an expiry and we store the link rather than a copy,
  // so a form built a while ago points at a dead URL. Painted as a CSS background that fails
  // to nothing, which is indistinguishable from a form that never had an image — so it falls
  // back to saying so instead.
  if (!source || failedSource === source) {
    return <MissingImageNotice />
  }

  return (
    <div className="image w-100" style={{ marginBottom: '-64px', height: '232px' }}>
      <img
        data-testid="background-image"
        src={source}
        alt=""
        onError={() => setFailedSource(source)}
        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
      />
    </div>
  )
}
